import DocumentVerificationPositiveBanner from './DocumentVerificationPositiveBanner';

export default DocumentVerificationPositiveBanner;
